import type {
  Code,
  CodeListResponse,
  Params,
  UpdateCodeResponse,
} from '@/domains/system-management/types/code';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const codeApi = {
  // Get code list
  getCodes: async (params: Params): Promise<CodeListResponse[]> => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    const url = `${URLS.BACK_DSH}${APIS.codeList(queryParams.toString())}`;
    return request.get(url);
  },

  // Get code details
  getCode: async (id: string): Promise<Code> => {
    const url = `${URLS.BACK_DSH}${APIS.detailCode(id)}`;
    return request.get(url);
  },

  // Create code
  createCode: async (data: Partial<Code>): Promise<{ id: string }> => {
    const url = `${URLS.BACK_DSH}${APIS.createUpperCode}`;
    return request.post(url, data);
  },

  // Create lower code
  createLowerCode: async (data: Partial<Code>): Promise<{ id: string }> => {
    const url = `${URLS.BACK_DSH}${APIS.createLowerCode}`;
    return request.post(url, data);
  },

  // Update code
  updateCode: async (id: string, data: Partial<Code>): Promise<UpdateCodeResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.updateUpperCode(id)}`;
    return request.put(url, data);
  },

  // Update code
  updateLowerCode: async (id: string, data: Partial<Code>): Promise<UpdateCodeResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.updateLowerCode(id)}`;
    return request.put(url, data);
  },

  // Delete code
  deleteCode: async (id: string): Promise<void> => {
    const url = `${URLS.BACK_DSH}${APIS.deleteCode(id)}`;
    return request.delete(url, id);
  },
};
